<div class="container auth-container">

	<header class="row header">

		<div class="col-lg-3 col-sm-6 pull-left">
			<img class="img-fluid" src="./assets/media//logos/logo.svg">
		</div>

		<div class="col-lg-3 col-sm-6 pull-right">
              <kt-language-selector-login></kt-language-selector-login>
		</div>

	</header>

	<div class="row auth-section justify-content-between">

		<div class="col-lg-4">
			<router-outlet></router-outlet>
		</div>

		<div class="col-lg-7 auth-section-img">
				<img class="img-fluid" src="./assets/media//bg/loginImage.svg">
		</div>

	</div>

</div>


<footer>
	<div class="container">
		<div class="row footer d-flex justify-content-center">

			<div class="col-lg-3 col-sm-6 pull-left footer-badge" hidden>
				<a href="https://apps.apple.com/us/app/apple-store/id375380948"><img class="Layer_6" src="./assets/media//bg/app_store_badge.svg"></a>
				<a href="https://play.google.com/store/apps?hl=en"><img class="saudi_taxi_car" src="./assets/media//bg/google-play-badge en.svg"></a>
			</div>

			<div class="col-lg-3 col-sm-6 login__footer--rights pull-right text-center">
				<p>{{'AUTH.GENERAL.RIGHTS' | translate}}</p>
			</div>
		</div>
	</div>
</footer>